/* Delivery cutoff countdown. Ticks to data-end (ISO with TZ offset, so it's correct
   regardless of the visitor's timezone). Shows/hides itself on variant change based on
   the per-variant in_stock data embedded by stock-status.liquid. */
if (!customElements.get('delivery-timer')) {
  class DeliveryTimer extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      this.h = this.querySelector('.js-h');
      this.m = this.querySelector('.js-m');
      this.s = this.querySelector('.js-s');
      if (!this.end || !this.h) return;

      this.tick = this.tick.bind(this);
      this.tick();
      this.interval = setInterval(this.tick, 1000);

      this.onVariant = this.onVariant.bind(this);
      document.addEventListener('on:variant:change', this.onVariant);
    }

    disconnectedCallback() {
      clearInterval(this.interval);
      document.removeEventListener('on:variant:change', this.onVariant);
    }

    pad(n) {
      return n < 10 ? '0' + n : '' + n;
    }

    tick() {
      const diff = this.end - Date.now();
      if (diff <= 0) {
        clearInterval(this.interval);
        this.classList.add('is-hidden');
        return;
      }
      const totalSec = Math.floor(diff / 1000);
      this.h.textContent = this.pad(Math.floor(totalSec / 3600));
      this.m.textContent = this.pad(Math.floor(totalSec / 60) % 60);
      this.s.textContent = this.pad(totalSec % 60);
    }

    onVariant(e) {
      const variant = e.detail && e.detail.variant;
      const data = this.stockData();
      if (!variant || !data) return;
      const info = data[variant.id];
      // Mirrors the Liquid rule above: delivery_time 0 means the item ships
      // today, whatever the in_stock flag says. Without this the clock vanishes
      // on variant switch even though the line above it still promises tomorrow.
      const inStock = info ? (!!info.in_stock || Number(info.edt) === 0) : false;
      this.classList.toggle('is-hidden', !inStock);
    }

    stockData() {
      const el = document.querySelector('[data-stock-status-data]');
      if (!el) return null;
      try {
        return JSON.parse(el.textContent);
      } catch (err) {
        return null;
      }
    }
  }

  customElements.define('delivery-timer', DeliveryTimer);
}
